const styles = theme => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
    border: '1px solid rgba(145, 158, 171, 0.32)',
    borderRadius: '16px',
    cursor: 'pointer',
    margin: '10px',
    gap: '12px',
    width: '240px',
    height: '190px',
    '&:hover': {
      border: '1px solid #015ffb',
      backgroundColor: '#E3F3FF',
    },
  },
  iconDiv: {
    borderRadius: '15px',
    padding: '8px',
    backgroundColor: '#F4F6F8',
  },
  iconDivHover: {
    backgroundColor: '#fff',
    borderRadius: '15px',
    padding: '8px',
  },
  cardTitle: {
    fontSize: '18px',
    fontWeight: 500,
    textAlign: 'center',
  },
  icon: {
    color: '#002E47',
    fontSize: '30px',
  },
  iconAi: {
    color: '#5A7DFA',
    fontSize: '30px',
  },
})

export default styles
